/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useGatewayDetail } from 'api/apiHooks';
import PartialPageSpinner from 'components/PartialPageSpinner';
import { GatewayType } from 'containers/manage/gateways/GatewaysListingType';
import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from 'routes/paths';
import PaypalGatewayOnboarding from './PaypalGatewayOnboarding';
import StripeOnboarding from './StripeOnboarding';

export default function GatewayDetailsOnboarding({
  onSubmit,
  loadingUserSubmit,
  paymentSelected,
  stripeKeyError,
  payPalKeyError,
}: {
  onSubmit: (data: any) => void;
  loadingUserSubmit: boolean;
  paymentSelected: GatewayType;
  stripeKeyError: any;
  payPalKeyError: any;
}) {
  const navigate = useNavigate();
  const { data, isError } = useGatewayDetail(paymentSelected._id);

  if (isError) {
    navigate(PATH_PAGE.page404);
  }
  if (data === undefined) {
    return <PartialPageSpinner />;
  }
  const gatewayDetails = data.data;

  const renderGateway = (name: string) => {
    switch (name) {
      case 'stripe':
        return <StripeOnboarding gatewayDetails={gatewayDetails} />;

      case 'paypal':
        return (
          <PaypalGatewayOnboarding
            gatewayDetails={gatewayDetails}
            onSubmit={onSubmit}
            loadingUserSubmit={loadingUserSubmit}
            payPalKeyError={payPalKeyError}
          />
        );

      default:
        return null;
    }
  };

  return renderGateway(gatewayDetails.name);
}
